import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { i18nSocietyType } from '../../../../../i18n'
import { theme } from '../../../../../theme/theme'
import {
  Illustration,
  IllustrationChoices,
} from '../../../../common/Illustration'
import { ISocietiesModel } from '../../../../../interfaces/models/societies.interfaces'

interface CanNotDeleteAccountProps {
  societiesPreventingAccountDeletion: ISocietiesModel[]
}

export const CanNotDeleteAccount = ({
  societiesPreventingAccountDeletion,
}: CanNotDeleteAccountProps): React.ReactNode => {
  const { translate } = useAppTranslation()

  return (
    <div className="flex flex-col gap-3">
      <div className="flex justify-center">
        <Illustration illustrationChoice={IllustrationChoices.CHECKLIST} />
      </div>
      <p style={theme.textVariants.h3}>
        {translate('deleteAccountModal.canNotDeleteTitle')}
      </p>
      <p style={theme.textVariants.base}>
        {translate('deleteAccountModal.canNotDeleteText', {
          context: i18nSocietyType(
            societiesPreventingAccountDeletion[0]?.societyTypeDisplayName
          ),
        })}
      </p>
      <div className="mt-1">
        {societiesPreventingAccountDeletion.map((_society) => (
          <p key={_society._id} style={theme.textVariants.baseBold}>
            {_society.name}
          </p>
        ))}
      </div>
    </div>
  )
}
